module.exports = __webpack_public_path__ + "img/ico-candidates.7fbdc3c3.svg";